// extracted by mini-css-extract-plugin
module.exports = {"bodyBg":"styles_bodyBg__2AN9e","container":"styles_container__1A-HA","logo":"styles_logo__68jSV","inner":"styles_inner__1BlT0"};